import { render, staticRenderFns } from "./UpLoad.vue?vue&type=template&id=10ff1a4a"
import script from "./UpLoad.vue?vue&type=script&lang=js"
export * from "./UpLoad.vue?vue&type=script&lang=js"
import style0 from "./UpLoad.vue?vue&type=style&index=0&id=10ff1a4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports